<template>
	<div class="card">
		<div
			class="card-header card-header-flex flex-column border-bottom-0 px-3 pt-3 pb-1"
			:class="$style.header"
		>
			<div
				class="flex-1"
				:class="$style.info"
			>
				<div>
					<h5 class="mb-1 text-white">
						{{ user.Nick }}
					</h5>
					<a-button
						ghost
						type="dashed"
						size="small"
					>
						{{ user.Group.Name }}
					</a-button>
				</div>
				<div class="ml-auto">
					<a-dropdown-button
						:trigger="['click']"
						size="small"
						:class="[$style.dropdown, $style['dropdown-'+status.class]]"
					>
						<span>
							<fa-icon :icon="['fa', status.icon]" /> {{ status.text }}
						</span>

						<a-menu slot="overlay">
							<a-menu-item>
								<a
									class="text-primary"
									@click="setStatus(0)"
								><fa-icon :icon="['fa', 'lock-open']" /> Activo</a>
							</a-menu-item>
							<a-menu-item>
								<a
									class="text-warning"
									@click="setStatus(1)"
								><fa-icon :icon="['fa', 'lock']" /> Inactivo</a>
							</a-menu-item>
							<a-menu-item>
								<a
									class="text-danger"
									@click="setStatus(2)"
								><fa-icon :icon="['fa', 'lock']" /> Bloqueado</a>
							</a-menu-item>
							<a-menu-divider />
							<a-menu-item>
								<a
									@click="$router.push({
										name: '_usersForm',
										params: { id: user.ID }
									})"
								>
									<fa-icon :icon="['far', 'edit']" /> Editar
								</a>
							</a-menu-item>
							<a-menu-item>
								<a-popconfirm

									title="¿Estas seguro que deseas eliminar este usuario?"
									@confirm="() => {deleteUser(user)}"
								>
									<a><fa-icon :icon="['far', 'trash-alt']" /> Eliminar</a>
								</a-popconfirm>
							</a-menu-item>
						</a-menu>
					</a-dropdown-button>
				</div>
			</div>

			<h2
				class="mt-auto mb-0 text-white"
				:class="$style.info"
			>
				#{{ user.ID }}
			</h2>
		</div>
		<div class="card-body p-0">
			<div
				class="text-right px-3"
				:class="$style.avatar"
			>
				<a-avatar
					shape="square"
					:src="$gestios.avatars(user.ID)"
					:size="100"
				/>
			</div>

			<div
				class="table-responsive mb-0"
			>
				<div class="row" />

				<table
					class="table table-striped mb-0 mt-2"
					:class="$style.table"
				>
					<tbody>
						<tr>
							<td class="font-weight-bold">
								<fa-icon :icon="['far','user']" /> Nombre
							</td>
							<td class="text-right">
								{{ user.Name }}
							</td>
						</tr>
						<tr>
							<td class="font-weight-bold">
								<fa-icon :icon="['far','envelope']" /> Email
							</td>
							<td class="text-right">
								<a :href="`mailto:${user.Email}`">{{ user.Email }}</a>
							</td>
						</tr>
						<tr>
							<td class="font-weight-bold">
								<fa-icon :icon="['fa','phone']" /> Teléfono
							</td>
							<td class="text-right">
								<a :href="`tel:${user.Phone}`">{{ user.Phone }}</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true
		}
	},
	computed: {
		status() {
			if (this.user.Status === '0') {
				return {
					class: 'primary',
					text: 'Activo',
					icon: 'lock-open'
				};
			} if (this.user.Status === '1') {
				return {
					class: 'warning',
					text: 'Inactivo',
					icon: 'lock'
				};
			}
			return {
				class: 'danger',
				text: 'Bloqueado',
				icon: 'lock'
			};
		}
	},
	methods: {
		setStatus(val) {
			this.$emit('status', { user: this.user, status: val });
		}
	}
};
</script>

<style lang="scss" module>
	.header{
		position: relative;
		height: 150px;
		overflow: hidden;
		background-color: $dark;

		.info{
			display: flex;
		}
	}

	.avatar {
		margin-top: -70px;
		padding-right: 10px;

		img{
			background: white;
			padding: 5px;
		}
	}

	.dropdown button:first-child{
		background: transparent;
		color: white;
	}

	.dropdown button:last-child{
		background: rgba(255,255,255,0.4);
		color: white;
	}

	.dropdown.dropdown-primary {
		button, button:hover, button:focus{
			border-color: $primary;
		}

		button, button:hover, button:focus{
			background: $primary;
			color: white;
		}
	}

	.dropdown.dropdown-warning {
		button, button:hover, button:focus{
			border-color: $warning;
		}

		button, button:hover, button:focus{
			background: $warning;
			color: white;
		}
	}

	.dropdown.dropdown-danger{
		button, button:hover, button:focus{
			border-color: $danger;
		}

		button, button:hover, button:focus{
			background: $danger;
			color: white;
		}
	}

	.table{
		tr td:first-child{
			min-width: 120px;
		}

		tr td:last-child{
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}

	.table tbody tr:nth-of-type(odd) {
		background: #fff !important;
	}

	.table tbody tr:nth-of-type(even) {
		background: #f2f4f8 !important;
	}

	[data-kit-theme="dark"] {
		.table tbody tr:nth-of-type(odd) {
			background: lighten($dark-gray-6, 1%) !important;
		}

		.table tbody tr:nth-of-type(even) {
			background: $dark-gray-4 !important;
		}

		.avatar {
			img{
				background: lighten($dark-gray-6, 1%) !important;
			}
		}
	}
</style>
